<template>
  <div class="room-detail-tags" @click="submit($event)">
    <ul v-if="tags && tags.length" class="tags-list">
      <template v-for="(item,index) in tags">
        <li v-if="index < viewNum" :key="'tag_' + index" >
          <img :src="item.icon || ''" :onerror="defaultImg" />
          <div>{{ getName(item.name) }}</div>
          <div class="common-clr"></div>
        </li>
      </template>
      <template v-if="isDetail">
      <li class="tags_view">
          <span class="tags_text">查看详情</span>
          <img class="tags_arrow" :src="`${imgUrl}/cruiseDetail/icons/icon-arrow-right.png`"/>
      </li>
      </template>
    </ul>
    <div class="common-clr"></div>
  </div>
</template>

<script>
export default {
  name: "DeviceFeatureTags",
  props: {
    isDetail: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    viewNum: {
      type: Number,
      default: 3
    },
    stateroom: {
      type: Object,
      default: null
    },
    idx: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
    }
  },
  computed: {
    defaultImg() {
      return "this.src = 'https://resource.rcclchina.com.cn/common/default/icon-default.png'"
    }
  },
  methods: {
    submit(e) {
      if(this.isDetail) {
        if(this.stateroom !== null) {
          this.$emit('submit', {event: e, stateroom: this.stateroom, idx: this.idx});
        } else {
          this.$emit('submit', e);
        }
      }
    },
    getName(name) {
      return name.lastIndexOf('-') >= 0 ? name.substr(0, name.lastIndexOf('-')) : name;
    }
  }
}
</script>

<style lang="less" scoped>
.room-detail-tags {
  font-size: 14px;
  margin-top: 6px;
  & .tags-list {
    float: left;
    margin-bottom: 0;
    & > li {
      display: inline-block;
      overflow: hidden;
      margin-right: 15px;
      cursor: pointer;
      & > img {
        float: left;
        height: 14px;
        width: 14px;
      }
      & > div {
        float: left;
        line-height: 14px;
        margin-left: 4px;
      }

      &.tags_view {
        margin-right: 0;
        & .tags_text {
          float: left;
          display: block;
          line-height: 14px;
          margin-right: 5px;
          cursor: pointer;
          color: #0073bb;
        }
        & .tags_arrow {
          float: left;
          height: 10px;
          width: 6px;
          cursor: pointer;
          margin-top: 2px;
        }
        & .tags_arrow.txt {
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
